import request from '@/utils/request'


//登录
export function login(a,b) {
  return request({
    url: '/api/manager/user/login/PC/system',
    method: 'post',
    params: {account :a,password :b}
  })
}

//注册
export function registe(a,b) {
    return request({
      url: '/api/manager/user/registe',
      method: 'post',
      params: {userTel :a,userCode :b}
    })
}

//验证码登录
export function loginByCode(a,b) {
  return request({
    url: '/api/manager/user/loginByCode/PC',
    method: 'post',
    params: {account:a,code:b}
  })
}

//修改密码
export function changePassword(params) {
  return request({
    url: '/api/manager/user/changePassword',
    method: 'post',
    params: params,
  })
}

//退出登录
export function outLogin(params) {
  return request({
    url: '/api/manager/user/outLogin/PC/system',
    method: 'post',
    params: {account:params},
  })
}

//轮播图
export function bannerList(params) {
  return request({
    url: '/api/tool/banner/bannerList',
    method: 'get',
    params: {page:1,size:3},
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js